import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-baddress',
  templateUrl: './baddress.component.html',
  styleUrls: ['./baddress.component.scss']
})
export class BaddressComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
